import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { Flex, Text, rem, FlexProps } from '@mantine/core';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

interface Props {
	title: string;
	link: string;
	icon: PredefinedIcons;
	background?: JSX.Element;
	dataTestId?: string;
}

export const DealLinkTile = ({ title, link, icon, background, dataTestId }: Props) => {
	return (
		<StyledLink data-testid={dataTestId} to={link}>
			<StyledContainer direction="column" align="start" justify="end" gap="1rem">
				<StyledCircleIcon>
					<Icon variant={icon} size="lg" />
				</StyledCircleIcon>
				<Text fz="lg" fw={600}>
					{title}
				</Text>
			</StyledContainer>
			{background}
			<Flex className="link-icon">
				<Icon variant="arrow-up-right" size="lg" />
			</Flex>
		</StyledLink>
	);
};

const StyledLink = styled(Link)`
	width: 100%;
	min-height: ${rem('156px')};
	position: relative;
	overflow: hidden;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	background-color: ${({ theme }) => theme.v3.colors.gray[0]};
	border-radius: 0.5rem;

	.link-icon {
		display: none;
		padding: 0.5rem;
		border-radius: 0.5rem;
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
		background-color: ${({ theme }) => theme.v3.colors.white[0]};
		color: ${({ theme }) => theme.v3.colors.dark[0]};
		position: absolute;
		bottom: 1rem;
		right: 1rem;
	}

	&:hover {
		border-color: ${({ theme }) => theme.v3.colors.blue[4]};
		box-shadow: 0px 2px 16px 0px #dcdfe040;
		transition: all 0.3s ease;

		.link-icon {
			display: flex;
			transition: all 0.3s ease;
		}
	}
`;

const StyledContainer = styled(Flex)<FlexProps>`
	padding: 1rem;
	position: absolute;
	height: 100%;
	width: 100%;
	z-index: 1;
`;

const StyledCircleIcon = styled(Flex)<FlexProps>`
	padding: 0.5rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 50%;
`;
